import port1 from '../../assets/agency.png'
import port2 from '../../assets/ecommarce.png'
import port3 from '../../assets/education.png'
import port4 from '../../assets/hospital.png'
import port5 from '../../assets/hotel.png'
import port6 from '../../assets/tour.png'

const Data = [
  {
    id: 1,
    img: port1,
    title: 'Agency',
    github: 'https://github.com/al-jabir/agency-website',
    demo: 'https://agency-websites.netlify.app/',
  },
  {
    id: 2,
    img: port2,
    title: 'E-Commarce',
    github: 'https://github.com/al-jabir/aj-clothing-shop',
    demo: 'https://clothing-shops.netlify.app/',
  },
  {
    id: 3,
    img: port3,
    title: 'Education',
    github: 'Github',
    demo: 'Live Demo',
  },
  {
    id: 4,
    img: port4,
    title: 'Hospital',
    github: 'Github',
    demo: 'Live Demo',
  },
  {
    id: 5,
    img: port5,
    title: 'Hotel booking',
    github: 'Github',
    demo: 'Live Demo',
  },
  {
    id: 6,
    img: port6,
    title: 'Travel',
    github: 'Github',
    demo: 'Live Demo',
  },
]

export default Data
